import { CREATE_ALERT, CLOSE_ALERT } from './types'

const getInitialState = () => ({
  alerts: []
})

const createAlert = (state, action) => {
  return {
    ...state,
    alerts: [...state.alerts, action.payload]
  }
}

const closeAlert = (state, action) => {
  let newAlerts = [...state.alerts]
  if (action.payload.id) {
    newAlerts = newAlerts.filter(alert => alert.id !== action.payload.id)
  } else {
    newAlerts.pop()
  }
  return {
    ...state,
    alerts: newAlerts
  }
}

const actionHandlers = {
  [CREATE_ALERT]: createAlert,
  [CLOSE_ALERT]: closeAlert
}

const reducer = (state = getInitialState(), action) => {
  if (actionHandlers[action.type]) {
    return actionHandlers[action.type](state, action)
  }
  return state
}
export default reducer